import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { SelectItem } from 'primeng';
import {
    address,
    blockSpecialCharachters,
    city,
    dose_input,
    GOOGLE_RECAPTCHA_SITE_KEY,
    name_input,
    number_input,
    phoneNumber,
    textareaBox,
    USER_TYPES,
    zipCode
} from 'src/app/constant/constant';
import { Patient_Registration_Data, UserTypes } from 'src/app/models/User';
import { CountriesService } from 'src/app/services/countries.service';
import { DaterenderService } from 'src/app/services/daterender.service';
import { UserService } from 'src/app/services/user.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { CountrySelectedValue } from 'src/app/models/doctorregistration';
import { TraceClassDecorator } from '@sentry/angular';
import { ApiResult, PromiseResult } from 'src/app/models/PromiseResult';
import { OtpInputComponent } from '../../shared/otp-input/otp-input.component';
import { CommunicationService } from '../../shared/communication.service';
import { ProviderStateService } from 'src/app/services/provider-state.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-register-patient',
    templateUrl: './register-patient.component.html',
    styleUrls: [
        './register-patient.component.css',
        './../login-home/login-home.component.css'
    ]
})
@TraceClassDecorator()
export class RegisterPatientComponent implements OnInit {

    @ViewChild(OtpInputComponent) OTP_Input: OtpInputComponent;

    readonly name_input: RegExp = name_input;
    readonly address: RegExp = address;
    readonly city_input: RegExp = city;
    readonly phoneNumber: RegExp = phoneNumber;
    readonly zipCode: RegExp = zipCode;
    readonly textarea: RegExp = textareaBox;
    readonly dose_input: RegExp = dose_input;
    readonly number_input: RegExp = number_input;
    readonly blockSpecialCharachters: RegExp = blockSpecialCharachters;
    readonly sitekey: string = GOOGLE_RECAPTCHA_SITE_KEY;
    readonly user_types: UserTypes = USER_TYPES;
    logo_url: string = '';
    provider_id: string = "";
    slug: string = "";
    terms_and_conditions_url: string =
        this.utilitiesService.getBaseUrl('HOMPAGE_BASE_URL') +
        'terms-of-use';
        userId: number;
    max_date: Date = this.utilitiesService.getMaxDate();
    isAyushupchar: boolean = false;
    patientreg: Patient_Registration_Data = new Patient_Registration_Data(
        this.terms_and_conditions_url,
        this.max_date
    );
    gender_list: SelectItem[] = [
        {
            label: "Male", value: "Male"
        },
        {
            label: "Female", value: "Female"
        },
        {
            label: "Other", value: "Other"
        }
    ]
    constructor(
        private readonly countriesService: CountriesService,
        private readonly daterenderService: DaterenderService,
        private readonly userservice: UserService,
        private readonly utilitiesService: UtilitiesService,
        private readonly changeDetector: ChangeDetectorRef,
        private readonly communicationService: CommunicationService,
        private providerStateService: ProviderStateService,
        private readonly router: Router,
        private readonly route: ActivatedRoute,
    ) {
        this.max_date = this.utilitiesService.getMaxDate();
        // this.date_of_birth_string=this.max_date;
    }

    async ngOnInit(): Promise<void> {
        this.patientreg = new Patient_Registration_Data(
            this.terms_and_conditions_url,
            this.max_date
        );
        this.slug = this.providerStateService.getProviderSlug();
        this.provider_id = this.providerStateService.getProviderId();
        this.route.queryParamMap.subscribe(async (res) => {
            if (res.get('user_source_id')) {
                this.patientreg.api_data.userPatient.user_source_id = parseInt(res.get('user_source_id'));
                this.isAyushupchar = true;
            } 
          });
        await this.getCountries();
        await this.fetchDataSources();
        
        this.patientreg.other_data.recaptchaData.reset();
        this.logo_url = this.providerStateService.getLogoUrl();
    }

    async getCountries(): Promise<void> {
        await this.countriesService
            .getCountries(this.provider_id)
            .toPromise()
            .then((countries) => {
                countries.forEach((ele) => {
                    ele["final_value"] = JSON.stringify({
                        id: Number(ele.id),
                        is_national_license: ele.is_national_license,
                        phone_code: '+' + String(ele.phone_code)
                    } as CountrySelectedValue);
                });
                this.patientreg.other_data.countries = this.utilitiesService.getSelectItemList(countries, "country_name", "final_value");
            }).catch((err) => {
                console.error(err);
            });
    }

    async onChangeCountry() {
        this.patientreg.other_data.selected_country_data =
            (JSON.parse(
                this.patientreg.other_data.selected_country
            ) as CountrySelectedValue) || new CountrySelectedValue();
        await this.countriesService
            .getStates(this.patientreg.other_data.selected_country_data?.id)
            .toPromise()
            .then((states) => {
                this.patientreg.other_data.states = this.utilitiesService.getSelectItemList(states, "state_name", "id");
            }).catch((err) => {
                console.error(err);
            });
    }

    async fetchDataSources() {
        await this.userservice
            .fetchSources()
            .toPromise()
            .then((result) => {
                this.patientreg.other_data.sources = this.utilitiesService.getSelectItemList(result, "user_source", "user_source_id");
            }).catch((err) => {
                console.error(err);
            });
    }

    async createUser(): Promise<void> {
        // this.patientreg.other_data.formPosting = true;
        this.patientreg.api_data.create_api_result = new ApiResult(true);
        // this.userPatient.date_of_birth_date=new Date(this.date_of_birth_string);
        this.patientreg.api_data.userPatient.date_of_birth =
            this.daterenderService.render_data(
                this.patientreg.api_data.userPatient.date_of_birth_date
            );
        this.patientreg.api_data.userPatient.country_id = Number(
            this.patientreg.other_data.selected_country_data.id
        );
        this.patientreg.api_data.userPatient.primary_contact_number =
            this.patientreg.other_data.selected_country_data.phone_code +
            this.patientreg.other_data.primary_contact_no;
        this.patientreg.api_data.userPatient.state_id = Number(
            this.patientreg.api_data.userPatient.state_id
        );
        this.patientreg.api_data.userPatient.user_source_id = Number(
            this.patientreg.api_data.userPatient.user_source_id
        );
        if (this.patientreg.api_data.userPatient.user_source_id != 12) {
            this.patientreg.api_data.userPatient.other_source = null;
        }

        this.patientreg.api_data.userPatient.e_email =
            Boolean(this.patientreg.api_data.userPatient.email) ? this.patientreg.api_data.userPatient.email : null


        // setting value null for new registration process to reduce the form size    
        this.patientreg.api_data.userPatient.confirmpassword = null;
        this.patientreg.api_data.userPatient.date_of_birth = null;
        this.patientreg.api_data.userPatient.date_of_birth_date = null;
        //this.patientreg.api_data.userPatient.e_password=null;
        this.patientreg.api_data.userPatient.e_email = null;
        this.patientreg.api_data.userPatient.gender = null;
        this.patientreg.api_data.userPatient.state_id = null;
        this.patientreg.api_data.userPatient.email = null;
        this.patientreg.api_data.userPatient.provider_id =  this.providerStateService.getProviderId();

        await this.userservice
            .createUser(this.patientreg.api_data.userPatient)
            .toPromise()
            .then((result) => {
                this.patientreg.api_data.create_api_result.PromiseResult = result;
                if (result.success) {
                    this.set_data(result);
                    this.patientreg.other_data.tabViewData.nextTab(1);
                }
                this.patientreg.api_data.create_api_result.Posting = false;
            })
            .catch((error: HttpErrorResponse) => {
                this.patientreg.api_data.create_api_result.ServerError = error.error;
                this.patientreg.api_data.create_api_result.PromiseResult.success = false;
                this.patientreg.api_data.create_api_result.Posting = false;
            });
    }

    setUser(user: any) {
        this.communicationService.setUser(user);
    }

    async register_validate_or_resend_otp() {
        this.patientreg.api_data.otp_data.otp_api_result = new ApiResult(true);
        await this.userservice
            .register_patient_validate_or_resend_otp(this.patientreg.api_data.otp_data.OTP_validate_api)
            .toPromise()
            .then(async (result) => {
                this.patientreg.api_data.otp_data.otp_api_result.PromiseResult = result;
                if (result.success) {
                    if (this.patientreg.api_data.otp_data.OTP_validate_api.retry) {
                        this.set_data(result);
                        await this.changeDetector.detectChanges();
                        await this.OTP_Input.init_countdown();
                    }
                    else {
                        sessionStorage.setItem('userid', result.data.userid);
                        sessionStorage.setItem('authtoken', result.data.authtoken);
                        sessionStorage.setItem('refresh', "true");
                        sessionStorage.setItem('refresh_token', result.data.refreshToken);
                        sessionStorage.setItem('email', 'default');
                        sessionStorage.setItem('name', 'default');

                        //Todo: need to change this based on role
                        this.setUser(this.patientreg.api_data.auth_result);
                        this.utilitiesService.RouterNavigation(
                            `/${this.user_types['PATIENT']}`
                        );
                    }
                }
                this.patientreg.api_data.otp_data.otp_api_result.Posting = false;
            })
            .catch((error: HttpErrorResponse) => {
                this.patientreg.api_data.otp_data.otp_api_result.ServerError = error.error;
                this.patientreg.api_data.otp_data.otp_api_result.PromiseResult.success = false;
                this.patientreg.api_data.otp_data.otp_api_result.Posting = false;
            })
    }

    set_data(result: PromiseResult) {
        this.patientreg.api_data.otp_data.OTP_validate_api.user_guid = result.data.user_guid;
        this.patientreg.api_data.otp_data.OTP_validate_api.service_id = result.data.service_id;
        this.patientreg.api_data.otp_data.OTP_validate_api.retry_after = new Date(result.data.retry_after);
    }

    resolved(captchaResponse: any) {
        this.patientreg.other_data.recaptchaData.recaptcha_value = captchaResponse;
        this.patientreg.api_data.userPatient.recaptcha =
            this.patientreg.other_data.recaptchaData.recaptcha_value;
    }



    async otp_resend() {
        this.patientreg.api_data.otp_data.OTP_validate_api.retry = true;
        await this.register_validate_or_resend_otp();
    }

    async userRegistrationSubmit() {
        // this.patientreg.other_data.formPosting = true;
        this.patientreg.other_data.recaptchaData.reset();
        //    await grecaptcha.reset();
        await this.createUser();
    }

    async otpVerifySubmit() {
        this.patientreg.api_data.otp_data.OTP_validate_api.retry = false;
        await this.register_validate_or_resend_otp();
    }

    isPosting(): boolean {
        return this.patientreg.api_data.create_api_result.Posting ||
            this.patientreg.api_data.otp_data.otp_api_result.Posting
    }

    async openLink(
        base_url_name: string,
        link: string,
        target: string
    ): Promise<void> {
        await this.utilitiesService.openWebsiteLinks(
            base_url_name,
            link,
            target
        );
    }

    getEmptyNumberChecker(value: number) {
        return this.utilitiesService.getEmptyNumberChecker(value);
    }
}
